import { extractStringValueSet } from './extract-properties';

export default class EdgeTranslateFormat {
    static readonly HL7_REF_LAB_ORM: string = 'hl7-ref-lab-orm';
    static readonly HL7_ORDER_CANCEL_ORM: string = 'hl7-order-cancel-orm';
    static readonly HL7_SEND_NUMBER_ORM: string = 'hl7-send-number-orm';
    static readonly HL7_DISCRETE_ORU: string = 'hl7-discrete-oru';
    static readonly HL7_PDF_ORU: string = 'hl7-pdf-oru';
    static readonly HL7_DISCRETE_AND_PDF_ORU: string = 'hl7-discrete-and-pdf-oru';
    static readonly JSON_GENOMIC_RESULT: string = 'json-genomic-result';
    static readonly JSON_HRD: string = 'json-hrd';
    static readonly JSON_PURIST: string = 'json-purist';
    static readonly FHIR_GENOMEX_BUNDLE: string = 'fhir-genomex-bundle';
    static readonly CSV_GENOMIC_RESULT: string = 'csv-genomic-result';
    static readonly HL7_VCF_LINK_ORU: string = 'hl7-vcf-link-oru';
    static readonly JSON_NP_MOLECULAR: string = 'json-np-molecular';
    static readonly JSON_NP_REFERENCE: string = 'json-np-reference';
    static readonly JSON_DIGIPATH_WSI_METADATA: string = 'json-digipath-wsi-metadata';
    static readonly HL7_ACCESSION_SAMPLE_ORU: string = 'hl7-accession-sample-oru';
    static readonly TEXT_PATIENT_MANIFEST: string = 'text-patient-manifest';
    static readonly JSON_MRD: string = 'json-mrd';
    static readonly CSV_MRD: string = 'csv-mrd';
    static readonly HL7_UNSOLICITED_DISCRETE_ORU: string = 'hl7-unsolicited-discrete-oru';
    static readonly HL7_UNSOLICITED_PDF_ORU: string = 'hl7-unsolicited-pdf-oru';
    static readonly HL7_UNSOLICITED_DISCRETE_AND_PDF_ORU: string = 'hl7-unsolicited-discrete-and-pdf-oru';
    static readonly PATHOLOGY_REPORT: string = 'pathology-report';
    static readonly FAMILIAL_HISTORY_SUPPLEMENTAL_FORM: string = 'familial-history-supplemental-form';
    static readonly SUPPLEMENTAL_BILLING_DATA_PRODUCT: string = 'supplemental-billing-data-product';
    static readonly PDF_GENOMIC_RESULT: string = 'pdf-genomic-result';
    static readonly PDF_HRD: string = 'pdf-hrd';
    static readonly PDF_NP_MOLECULAR: string = 'pdf-np-molecular';
    static readonly PDF_NP_REFERENCE: string = 'pdf-np-reference';
    static readonly PDF_DPYD: string = 'pdf-dpyd';
    static readonly PDF_PURIST: string = 'pdf-purist';
    static readonly DOCUMENT_INGRESS: string = 'document-ingress';
    static readonly ORDER_STATUS: string = 'order-status';
    static readonly PDF_NP_GENE_DRUG: string = 'pdf-np-gene-drug';
    static readonly PDF_NP_EMERGING_EVIDENCE: string = 'pdf-np-emerging-evidence';
    static readonly JSON_NP_GENE_DRUG: string = 'json-np-gene-drug';
    static readonly DIAGNOSTIC_REPORT: string = 'diagnostic-report';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {
        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
